import {Clock, Phone} from "lucide-react";

import {cn} from "@/lib/utils";
import {formatUsPhoneDisplay, normalizeUsPhoneDigits} from "@/src/modules/properties/lib/us-phone";

import {RESIDENT_HOME_BLOCK_SHELL_CLASS} from "../lib/resident-home-block-layout";

type ResidentHomeNeedHelpProps = {
  supportPhone: string;
  className?: string;
  /** Footer inside welcome card — no outer shell. */
  embedded?: boolean;
};

function NeedHelpContent({supportPhone}: {supportPhone: string}) {
  const displayPhone = formatUsPhoneDisplay(supportPhone);
  const telHref = `tel:${normalizeUsPhoneDigits(supportPhone)}`;

  return (
    <>
      <span className="text-foreground text-xs font-medium">Need help?</span>
      <a
        href={telHref}
        className="text-primary inline-flex items-center gap-1 text-sm font-semibold hover:underline"
      >
        <Phone className="size-3.5 shrink-0" aria-hidden />
        {displayPhone}
      </a>
      <span className="text-muted-foreground inline-flex items-center gap-1 text-xs">
        <Clock className="size-3 shrink-0" aria-hidden />
        24/7 support
      </span>
    </>
  );
}

/** Standalone strip between page sections (legacy). Prefer `embedded` inside welcome card. */
export function ResidentHomeSupportStrip({supportPhone, className}: ResidentHomeNeedHelpProps) {
  return (
    <section
      className={cn(
        "border-border bg-muted/40 flex flex-wrap items-center gap-x-3 gap-y-1",
        RESIDENT_HOME_BLOCK_SHELL_CLASS,
        className,
      )}
    >
      <NeedHelpContent supportPhone={supportPhone} />
    </section>
  );
}

export function ResidentHomeNeedHelpFooter({supportPhone, className}: ResidentHomeNeedHelpProps) {
  return (
    <div
      className={cn(
        "border-border flex flex-wrap items-center gap-x-3 gap-y-1",
        className,
      )}
    >
      <NeedHelpContent supportPhone={supportPhone} />
    </div>
  );
}
